import { PATHWAY_STEPS } from '../constants';
import SectionLabel from './section-label';

function PathwaySection() {
  return (
    <section id="pathway" className="bg-hub-sky px-5 py-20 text-hub-forest md:py-28">
      <div className="mx-auto max-w-7xl">
        <div className="grid gap-10 md:grid-cols-12 md:items-end">
          <div className="md:col-span-7">
            <SectionLabel eyebrow="Pathway" title="A simple rhythm for turning good intentions into good days." />
          </div>
          <p className="text-lg leading-8 text-hub-muted md:col-span-5">
            Each step keeps the focus practical: listen carefully, participate locally, and grow through steady relationships.
          </p>
        </div>
        <div className="mt-12 grid gap-5 md:grid-cols-3">
          {PATHWAY_STEPS.map((step) => (
            <article key={step.step} className="rounded-[2rem] border border-hub-forest/10 bg-hub-paper p-7 shadow-soft">
              <p className="font-display text-5xl font-bold text-hub-coral">{step.step}</p>
              <h3 className="mt-8 font-display text-3xl font-bold">{step.title}</h3>
              <p className="mt-4 leading-7 text-hub-muted">{step.body}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default PathwaySection;
